import produce from 'immer';
import {
  GET_DASHBOARD_TASKS_REQUEST,
  GET_DASHBOARD_TASKS_SUCCESS,
  GET_DASHBOARD_TASKS_FAILURE,
  GET_EXPENSE_FOLLOWUP_REQUEST,
  GET_EXPENSE_FOLLOWUP_SUCCESS,
  GET_EXPENSE_FOLLOWUP_FAILURE,
  GET_RECURRING_PAYABLES_DASHBOARD_REQUEST,
  GET_RECURRING_PAYABLES_DASHBOARD_SUCCESS,
  GET_RECURRING_PAYABLES_DASHBOARD_FAILURE,
  GET_EXTERNAL_COMMENTS_REQUEST,
  GET_EXTERNAL_COMMENTS_SUCCESS,
  GET_EXTERNAL_COMMENTS_FAILURE,
  GET_EXCEPTION_COMMENTS_REQUEST,
  GET_EXCEPTION_COMMENTS_SUCCESS,
  GET_EXCEPTION_COMMENTS_FAILURE,
  ATTEMPT_TASK_REQUEST,
  ATTEMPT_TASK_SUCCESS,
  ATTEMPT_TASK_FAILURE,
  COMPLETE_TASK_REQUEST,
  COMPLETE_TASK_SUCCESS,
  COMPLETE_TASK_FAILURE,
  CANCEL_TASK_REQUEST,
  CANCEL_TASK_SUCCESS,
  CANCEL_TASK_FAILURE,
  CREATE_MANUAL_TASK_REQUEST,
  CREATE_MANUAL_TASK_SUCCESS,
  CREATE_MANUAL_TASK_FAILURE,
  GET_VOUCHER_CONTEXT_REQUEST,
  GET_VOUCHER_CONTEXT_SUCCESS,
  GET_VOUCHER_CONTEXT_FAILURE,
  GET_LETTER_TEMPLATE_REQUEST,
  GET_LETTER_TEMPLATE_SUCCESS,
  GET_LETTER_TEMPLATE_FAILURE,
  GET_RC_FILES_REQUEST,
  GET_RC_FILES_SUCCESS,
  GET_RC_FILES_FAILURE,
  GET_LETTER_TEMPLATES_REQUEST,
  GET_LETTER_TEMPLATES_SUCCESS,
  GET_LETTER_TEMPLATES_FAILURE,
  GET_TASK_COMMENTS_REQUEST,
  GET_TASK_COMMENTS_SUCCESS,
  GET_TASK_COMMENTS_FAILURE,
  SET_DASHBOARD_FILTERS,
  SET_TASK_FILTERS,
  SET_EXPENSE_FILTERS,
  SET_EXTERNAL_COMMENTS_FILTERS,
  SET_EXCEPTION_COMMENTS_FILTERS,
  RESET_FILTERS,
  SET_ACTIVE_MODAL,
  CLOSE_MODAL,
} from './types';

const initialState = {
  tasks: [],
  expenseFollowUp: [],
  recurringPayables: [],
  externalComments: [],
  exceptionComments: [],
  taskComments: {},
  isLoadingTasks: false,
  isLoadingExpenses: false,
  isLoadingRecurringPayables: false,
  isLoadingExternalComments: false,
  isLoadingExceptionComments: false,
  error: null,
  filters: {
    clientId: null,
    fileId: null,
    taskTypeId: null,
    vendorId: null,
    isVIP: null,
    taskImportanceId: null,
    taskStatusId: null,
    dueDate: null,
  },
  expenseFilters: {
    statusName: null,
    clientId: null,
    daysRange: null,
  },
  externalCommentsFilters: {
    dateRange: null,
    clientId: null,
    searchText: null,
  },
  exceptionCommentsFilters: {
    status: null,
    dateRange: null,
    clientId: null,
  },
  voucherContext: null,
  letterTemplate: null,
  activeModal: null,
  selectedTask: null,
};

export default produce((draft = initialState, action) => {
  switch (action.type) {
    default:
      break;
    // Get Dashboard Tasks
    case GET_DASHBOARD_TASKS_REQUEST:
      draft.isLoadingTasks = true;
      draft.error = null;
      break;

    case GET_DASHBOARD_TASKS_SUCCESS:
      draft.tasks = action.response || [];
      draft.isLoadingTasks = false;
      draft.error = null;
      break;

    case GET_DASHBOARD_TASKS_FAILURE:
      draft.isLoadingTasks = false;
      draft.error = action.messages || ['Failed to load tasks'];
      break;

    // Get Expense Follow-up
    case GET_EXPENSE_FOLLOWUP_REQUEST:
      draft.isLoadingExpenses = true;
      break;

    case GET_EXPENSE_FOLLOWUP_SUCCESS:
      draft.expenseFollowUp = action.response || [];
      draft.isLoadingExpenses = false;
      break;

    case GET_EXPENSE_FOLLOWUP_FAILURE:
      draft.isLoadingExpenses = false;
      draft.error = action.messages || ['Failed to load expenses'];
      break;

    case GET_RECURRING_PAYABLES_DASHBOARD_REQUEST:
      draft.isLoadingRecurringPayables = true;
      break;

    case GET_RECURRING_PAYABLES_DASHBOARD_SUCCESS:
      draft.recurringPayables = action.response || [];
      draft.isLoadingRecurringPayables = false;
      break;

    case GET_RECURRING_PAYABLES_DASHBOARD_FAILURE:
      draft.isLoadingRecurringPayables = false;
      draft.error = action.messages || ['Failed to load recurring payables'];
      break;

    // Get External Comments
    case GET_EXTERNAL_COMMENTS_REQUEST:
      draft.isLoadingExternalComments = true;
      break;

    case GET_EXTERNAL_COMMENTS_SUCCESS:
      draft.externalComments = action.response || [];
      draft.isLoadingExternalComments = false;
      break;

    case GET_EXTERNAL_COMMENTS_FAILURE:
      draft.isLoadingExternalComments = false;
      draft.error = action.messages || ['Failed to load external comments'];
      break;

    // Get Exception Comments
    case GET_EXCEPTION_COMMENTS_REQUEST:
      draft.isLoadingExceptionComments = true;
      break;

    case GET_EXCEPTION_COMMENTS_SUCCESS:
      draft.exceptionComments = action.response || [];
      draft.isLoadingExceptionComments = false;
      break;

    case GET_EXCEPTION_COMMENTS_FAILURE:
      draft.isLoadingExceptionComments = false;
      draft.error = action.messages || ['Failed to load exception comments'];
      break;

    // Attempt Task
    case ATTEMPT_TASK_REQUEST:
      draft.isLoadingTasks = true;
      break;

    case ATTEMPT_TASK_SUCCESS:
      draft.isLoadingTasks = false;
      draft.activeModal = null;
      draft.selectedTask = null;
      break;

    case ATTEMPT_TASK_FAILURE:
      draft.isLoadingTasks = false;
      draft.error = action.messages || ['Failed to attempt task'];
      break;

    // Complete Task
    case COMPLETE_TASK_REQUEST:
      draft.isLoadingTasks = true;
      break;

    case COMPLETE_TASK_SUCCESS:
      draft.isLoadingTasks = false;
      draft.activeModal = null;
      draft.selectedTask = null;
      break;

    case COMPLETE_TASK_FAILURE:
      draft.isLoadingTasks = false;
      draft.error = action.messages || ['Failed to complete task'];
      break;

    // Cancel Task
    case CANCEL_TASK_REQUEST:
      draft.isLoadingTasks = true;
      break;

    case CANCEL_TASK_SUCCESS:
      draft.isLoadingTasks = false;
      draft.activeModal = null;
      draft.selectedTask = null;
      break;

    case CANCEL_TASK_FAILURE:
      draft.isLoadingTasks = false;
      draft.error = action.messages || ['Failed to cancel task'];
      break;

    // Create Manual Task
    case CREATE_MANUAL_TASK_REQUEST:
      draft.isLoadingTasks = true;
      break;

    case CREATE_MANUAL_TASK_SUCCESS:
      draft.isLoadingTasks = false;
      break;

    case CREATE_MANUAL_TASK_FAILURE:
      draft.isLoadingTasks = false;
      draft.error = action.messages || ['Failed to create task'];
      break;

    // Get Voucher Context
    case GET_VOUCHER_CONTEXT_REQUEST:
      break;

    case GET_VOUCHER_CONTEXT_SUCCESS:
      draft.voucherContext = action.response;
      break;

    case GET_VOUCHER_CONTEXT_FAILURE:
      draft.error = action.messages || ['Failed to load voucher context'];
      break;

    // Get Letter Template
    case GET_LETTER_TEMPLATE_REQUEST:
      break;

    case GET_LETTER_TEMPLATE_SUCCESS:
      draft.letterTemplate = action.response ?? null;
      break;

    case GET_LETTER_TEMPLATE_FAILURE:
      draft.error = action.messages || ['Failed to load letter template'];
      break;

    // Filters
    case SET_DASHBOARD_FILTERS:
      Object.assign(draft.filters, action.payload);
      break;

    case SET_TASK_FILTERS:
      Object.assign(draft.filters, action.payload);
      break;

    case SET_EXPENSE_FILTERS:
      draft.expenseFilters = { ...draft.expenseFilters, ...action.payload };
      break;

    case SET_EXTERNAL_COMMENTS_FILTERS:
      draft.externalCommentsFilters = { ...draft.externalCommentsFilters, ...action.payload };
      break;

    case SET_EXCEPTION_COMMENTS_FILTERS:
      draft.exceptionCommentsFilters = { ...draft.exceptionCommentsFilters, ...action.payload };
      break;

    case RESET_FILTERS:
      draft.filters = initialState.filters;
      draft.expenseFilters = initialState.expenseFilters;
      draft.externalCommentsFilters = initialState.externalCommentsFilters;
      draft.exceptionCommentsFilters = initialState.exceptionCommentsFilters;
      break;

    // Modal Management
    case SET_ACTIVE_MODAL:
      draft.activeModal = action.payload.modalType;
      draft.selectedTask = action.payload.task;
      break;

    case CLOSE_MODAL:
      draft.activeModal = null;
      draft.selectedTask = null;
      draft.voucherContext = null;
      draft.letterTemplate = null;
      break;

    // Get Task Comments
    // Clear the previous task's comments so a failed load cannot show them under another task
    case GET_TASK_COMMENTS_REQUEST:
      draft.taskComments = [];
      break;

    case GET_TASK_COMMENTS_SUCCESS:
      draft.taskComments = action.response || [];
      break;

    case GET_TASK_COMMENTS_FAILURE:
      draft.error = action.messages || ['Failed to load task comments'];
      break;

    // Get RC Files - handled in component state, not Redux
    case GET_RC_FILES_REQUEST:
    case GET_RC_FILES_SUCCESS:
    case GET_RC_FILES_FAILURE:
      break;

    // Get Letter Templates - handled in component state, not Redux
    case GET_LETTER_TEMPLATES_REQUEST:
    case GET_LETTER_TEMPLATES_SUCCESS:
    case GET_LETTER_TEMPLATES_FAILURE:
      break;
  }
  return draft;
}, initialState);
